//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

    props: {
        item: {
            required: true
        },
        readonly: {
            default: false
        }
    },

    data: function data() {
        return {
            initialized: false
        };
    },


    computed: {
        numberFormat: function numberFormat() {
            var val = parseInt(this.item.price);
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}],"syntax-dynamic-import"]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/templates/semperit/assets/js/modules/checkout/components/cart/components/CartRowCharge.vue
// module id = bBfY
// module chunks = 4